module.exports = __webpack_public_path__ + "img/2_Layne_GettyImages-985138658@3x.908a8aff.jpg";